const ROUTES_ENUMS = {
  HOME: '/',
  TOUR_DETAILS: '/tour-details/:packageId',
  EVENT_DETAILS: '/event-details/:eventId',
  ABOUT_US: '/about-us',
  CONTACT_US: '/contact-us',
  REGISTER: '/register',
  CHECKOUT: '/checkout/:packageId',
  MY_BOOKINGS: '/my-bookings',
  MY_PROFILE: '/my-profile',
  MY_WISHLIST: '/my-wishlist',
  CATEGORIES: '/categories',
  TOP_PACKAGES: '/top-packages',
  FAQ: '/faq',
  TERMS_CONDITION: '/temrs-condition',
};
export default ROUTES_ENUMS;
